import React, { useId } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').EventFilters}
 */
const EventFilters = ({
    isPast,
    onTogglePast,
    onToggleEventType,
    options,
    value
}) => {
    const legendId = useId();
    const pastId = useId();

    return (
        <div>
            {options.length > 0 && (
                <div
                    aria-labelledby={legendId}
                    role='group'>
                    <p
                        className='type-style-body-bold'
                        id={legendId}>
                        Event Type
                    </p>

                    <ul className='flex flex-wrap gap-8 mt-8'>
                        {options.map((option) => {
                            const active = value.includes(option.value);

                            return (
                                <li key={option.value}>
                                    <button
                                        aria-pressed={active}
                                        className={`button-tag button-hollow${active ? ' button-hollow--active' : ''}`}
                                        onClick={onToggleEventType.bind(this, option.value)}
                                        type='button'>
                                        {option.label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            <p className='flex items-center gap-x-8 mt-16'>
                <input
                    checked={isPast}
                    className='w-12 h-12'
                    id={pastId}
                    onChange={onTogglePast}
                    type='checkbox' />

                <label
                    className='type-style-body'
                    htmlFor={pastId}>
                    Past Events
                </label>
            </p>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default EventFilters;
